type RespostaFeedbackHttp = {
  status?: number
  data?: { sucesso?: boolean; codigo?: string; success?: unknown; error?: unknown; detail?: unknown; mensagem?: unknown }
  body?: { sucesso?: boolean; codigo?: string; success?: unknown; error?: unknown; detail?: unknown; mensagem?: unknown }
}

export function obterFeedbackHttp (
  resposta: RespostaFeedbackHttp,
  traduzir: (chave: string) => string
): string | undefined {
  const dados = resposta.data ?? resposta.body
  for (const mensagem of [dados?.success, dados?.error, dados?.detail, dados?.mensagem]) {
    if (typeof mensagem === 'string' && mensagem) return mensagem
  }
  if (!resposta.status) return undefined
  if (resposta.status >= 200 && resposta.status < 300) return traduzir('comuns.feedbackHttp.sucesso')
  if (resposta.status === 403) return traduzir('comuns.feedbackHttp.semPermissao')
  if (resposta.status >= 500 && resposta.status < 600) return traduzir('comuns.feedbackHttp.erroServidor')
  if (resposta.status >= 400 && resposta.status < 500) return traduzir('comuns.feedbackHttp.erroInesperado')
  return undefined
}
